import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/** Same grace threshold used by the inbox. */
export const CALLS_BALANCE_THRESHOLD = -10;

/**
 * Fail-closed balance check for the calls runtime.
 *
 * @param {unknown} rawBalance
 * @returns {boolean}
 */
export function hasSufficientCallsBalance(rawBalance) {
  if (typeof rawBalance !== 'number' && typeof rawBalance !== 'string') return false;

  const value = typeof rawBalance === 'string' ? rawBalance.trim() : rawBalance;
  if (value === '') return false;

  const balance = Number(value);
  return Number.isFinite(balance) && balance > CALLS_BALANCE_THRESHOLD;
}

/**
 * Retailer balance gate for mounting the Voice/Fonema runtime.
 *
 * @returns {boolean}
 */
export default function useCallsBalance() {
  const wsBalance = useSelector(
    (state) => state.mainReducer?.currentRetailerUser?.ws_balance
  );

  return useMemo(() => hasSufficientCallsBalance(wsBalance), [wsBalance]);
}
